import React, { useState } from "react";
import { FaChevronDown } from "react-icons/fa";

// 등록된 카테고리 선택만 담당한다. 추가·삭제는 상품 관리의 카테고리 관리 모달이 맡는다.
const CategorySelector = ({ categories, selectedCategory, onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleSelect = (category) => {
    onSelect(category);
    setIsOpen(false);
  };

  return (
    <div className="relative w-full">
      {/* ✅ 선택된 카테고리 (X 버튼 제거) */}
      <div
        className="border border-gray-300 rounded-lg px-3 py-2 flex items-center justify-between bg-white shadow-sm cursor-pointer hover:shadow-md transition-all"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="flex flex-wrap items-center gap-2">
          {selectedCategory ? (
            <div className="bg-blue-100 text-blue-700 px-2 py-1 rounded-lg">
              {selectedCategory}
            </div>
          ) : (
            <span className="text-gray-500">카테고리 선택</span>
          )}
        </div>
        <FaChevronDown className="text-gray-500" />
      </div>

      {/* ✅ 드롭다운 메뉴 */}
      {/* 카테고리가 늘어나면 목록이 화면 밖으로 넘치므로 높이를 제한하고 스크롤한다 */}
      {isOpen && (
        <div className="absolute w-full mt-2 bg-white border border-gray-300 shadow-lg rounded-lg z-10 max-h-60 overflow-y-auto">
          {/* 기존 카테고리 리스트 */}
          {categories.map((category, index) => (
            <div
              key={index}
              className="px-4 py-2 hover:bg-gray-100 transition-all cursor-pointer"
              onClick={() => handleSelect(category)}
            >
              {category}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CategorySelector;